import { REFERRAL_QR_PNG } from '../config';

type DownloadReferralQrPngParams = {
  qrCanvas: HTMLCanvasElement;
  link: string;
};

const canvasToPngBlob = (canvas: HTMLCanvasElement) =>
  new Promise<Blob | null>((resolve) => {
    canvas.toBlob(resolve, 'image/png');
  });

export const downloadReferralQrPng = async ({
  qrCanvas,
  link,
}: DownloadReferralQrPngParams) => {
  const {
    width,
    height,
    padding,
    qrSize,
    textCenterY,
    fontSize,
    fontFamily,
    fileName,
  } = REFERRAL_QR_PNG;

  const canvas = document.createElement('canvas');
  canvas.width = width;
  canvas.height = height;

  const context = canvas.getContext('2d');

  if (!context) {
    throw new Error('2D canvas context is unavailable');
  }

  // Printed and scanned, so black on white whatever the UI theme.
  context.fillStyle = '#ffffff';
  context.fillRect(0, 0, width, height);
  context.drawImage(qrCanvas, padding, padding, qrSize, qrSize);

  // fillText's maxWidth squeezes glyphs instead of wrapping, so a link wider
  // than the band gets a smaller font rather than condensed letters.
  const maxTextWidth = width - padding * 2;

  context.fillStyle = '#000000';
  context.font = `${fontSize}px ${fontFamily}`;

  const textWidth = context.measureText(link).width;

  if (textWidth > maxTextWidth) {
    const fittedFontSize = Math.floor((fontSize * maxTextWidth) / textWidth);
    context.font = `${fittedFontSize}px ${fontFamily}`;
  }

  context.textAlign = 'center';
  context.textBaseline = 'middle';
  context.fillText(link, width / 2, textCenterY, maxTextWidth);

  const blob = await canvasToPngBlob(canvas);

  if (!blob) {
    throw new Error('The QR code image could not be encoded');
  }

  const url = URL.createObjectURL(blob);

  // Firefox ignores click() on a detached anchor, and revoking synchronously
  // races the start of the download in several engines.
  const anchor = document.createElement('a');
  anchor.href = url;
  anchor.download = fileName;
  document.body.appendChild(anchor);
  anchor.click();
  anchor.remove();

  setTimeout(() => URL.revokeObjectURL(url));
};
